import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { StackSection } from 'store/stack';
import { FieldView } from './FieldView';
import { apiTranslate } from 'translations/translations';

type SectionProps = {
  section: StackSection;
};

const useStyles = makeStyles((theme) => ({
  title: {
    padding: '0.4rem 1rem 0.4rem 1rem',
    width: '100%',
    backgroundColor: theme.palette.secondary.light,
  },
  content: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

const SectionView = ({ section }: SectionProps) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.title}>
        <Typography variant="h4">
          {section.title ? apiTranslate(section.title) : null}
        </Typography>
      </div>

      <Grid item xs={6} className={classes.content}>
        <Grid container direction="row" alignItems="flex-start" spacing={6}>
          {section.fields?.map((field, i) => (
            <FieldView key={field.id + i} field={field} />
          ))}
        </Grid>
      </Grid>
    </>
  );
};

export { SectionView };
